/**
 * AbilityTestRig — shared types + section chrome.
 *
 * Extracted from the AbilityTestRig monolith so the override / cast-bench /
 * rotation-macro sub-panels can share the override flag shape, the loose
 * player typing, and the `Section` wrapper. Styling sits on theme tokens.
 */

import React, { type ReactNode } from 'react';
import type { Helix2000Character } from '../../../../shared/CharacterTypes';
import { rigStyles } from './abilityRigStyles';

/** The four dev-bypass override flags this rig drives. */
export interface OverrideFlags {
  infiniteMana: boolean;
  noCooldowns: boolean;
  noGCD: boolean;
  noRangeGate: boolean;
}

/**
 * The local player object with the dev-bypass override fields the rig
 * mutates client-side. These live on the Colyseus `Player` schema
 * server-side; on the local `Helix2000Character` they are written ad-hoc
 * for client-side prediction skip (see applyOverrideLocal). Typed here so
 * the rig never falls back to `any`.
 */
export type OverridablePlayer = Helix2000Character & {
  infiniteMana?: boolean;
  noCooldowns?: boolean;
  gcdOverride?: number;
  noRangeGate?: boolean;
};

export const Section: React.FC<{ title: string; children: ReactNode; style?: React.CSSProperties }> = ({
  title,
  children,
  style,
}) => (
  <section style={{ ...rigStyles.sectionCard, ...style }}>
    <header style={rigStyles.sectionHeader}>{title}</header>
    {children}
  </section>
);

